// this is an autogenerated file from App/Account/Content/Settings/Content/CommsEmail/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_CommsEmail{
  session_user_locations {
    id
    _id
  }
}

`